/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Overdue
 * 
 * 1 = Priority
 * 
 * 2 = Normal
 */
export enum PriorityStatus {
  Overdue = 0,
  Priority = 1,
  Normal = 2
}
